import { Component, OnInit } from '@angular/core';
import { faAt, faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  errorMessage: any = '';

  constructor(public bsModalRef: BsModalRef, public options: ModalOptions) {
    this.errorMessage = this.options?.initialState;
  }

  ngOnInit(): void {}

  close() {
    this.bsModalRef?.hide();
  }
}
